import React, { useState, useContext } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import { UserPortalContext } from '../../context/appcontext';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box } from '@material-ui/core';
import downloadIcon from '../../assets/SVGs/download-icon.svg';
import PropTypes from 'prop-types';
import { getWeek } from './utils';
import {
	ExcelFile,
	ExcelSheet,
	ExcelColumn,
} from '../../common/components/export-to-excel/index';
import { GUIDED_INSIGHTS_HOME } from '../../constants/constant';
import { useSelector, useDispatch } from 'react-redux';
import { saveEventTrack } from '../../redux/actions/eventTrackAction';
import DownloadIcon from '../../assets/SVGs/download-icon.svg';

const useStyles = makeStyles(() => ({
	button_ellipsis: {
		width: '40px',
		height: '40px',
	},
	menuOptions: {
		fontFamily: 'Bogle-Regular',
		fontSize: '16px',
		lineHeight: '16px',
		marginLeft: '3%',
	},
}));

const getDataColumns = ({ chartData }) => {
	return (
		<ExcelSheet data={chartData} name="Data">
			<ExcelColumn label="This Year Week" value="currentWeek" />
			<ExcelColumn
				label="This Year Percentage"
				value="current_percentage_tooltip"
			/>
			<ExcelColumn label="This Year Duration" value="current_duration" />

			<ExcelColumn label="Last Year Week" value="excel_ly_current_week" />
			<ExcelColumn
				label="Last Year Percentage"
				value="ly_current_percentage_tooltip"
			/>
			<ExcelColumn label="Last Year Duration" value="ly_current_duration" />

			<ExcelColumn label="Previous Period Week" value="previousWeek" />
			<ExcelColumn
				label="Previous Period Percentage"
				value="previous_percentage_tooltip"
			/>
			<ExcelColumn label="Previous Period Duration" value="previous_duration" />
			<ExcelColumn label="BPS Change Last year" value="bps_change_ly" />
			<ExcelColumn label="BPS Change Ref" value="bps_change_ref" />
		</ExcelSheet>
	);
};

const getMetaColumns = ({ metaData }) => {
	return (
		<ExcelSheet data={metaData} name="Meta Data">
			<ExcelColumn label="Note" value="note" />
			<ExcelColumn
				label="File Generation Timestamp"
				value="fileGenerationTimestamp"
			/>
			<ExcelColumn label="Parent Company Name" value="parentCompany" />
			<ExcelColumn label="Timeframe" value="timeframe" />
			<ExcelColumn label="Metric Name" value="metricName" />
		</ExcelSheet>
	);
};

const DownloadSupplierShare = ({ data, chartTitle }) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const portalUserContext = useContext(UserPortalContext);
	const parentCompanyName = portalUserContext?.result?.companyName;
	const downloadTime = new Date().toLocaleString()?.replace(',', ' ');
	const fileName = `${chartTitle}-Scintilla-Channel Performance-${downloadTime}`;
	const open = Boolean(anchorEl);
	const classes = useStyles({});
	const dispatch = useDispatch();

	const selectedFilters = useSelector(
		(state) => state.salesReducer.selectedFilters
	);

	const { startWeek, endWeek, weekFilter, selectedFilter } = selectedFilters;

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const handleOnClick = () => {
		const request = {
			event: 'Download',
			event_description: 'Supplier Share Chart .Xlsx report',
			attributes: GUIDED_INSIGHTS_HOME,
		};
		dispatch(saveEventTrack({ request, portalUserContext }));
		setAnchorEl(null);
	};

	const metaData = [
		{
			parentCompany: parentCompanyName,
			timeframe: getWeek(weekFilter, startWeek, endWeek),
			selectedFilter: selectedFilter,
			metricName: chartTitle,
			fileGenerationTimestamp: `${downloadTime}`,
			note: `The downloaded data is governed by contract terms between Scintilla and ${parentCompanyName}`,
		},
	];

	const chartData = data?.details;

	return (
		<>
			<IconButton
				sx={{
					padding: 0,
				}}
				size="medium"
				className={classes.button_ellipsis}
				onClick={handleClick}>
				<img alt="Download" src={downloadIcon} />
			</IconButton>

			<Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'center',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				MenuListProps={{
					'aria-labelledby': 'basic-button',
				}}>
				<MenuItem>
					<ExcelFile
						element={
							<Box
								style={{
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
								}}>
								<img alt="Download" src={DownloadIcon} />
								<Typography
									className={classes.menuOptions}
									onClick={handleOnClick}>
									Download in .xlsx
								</Typography>
							</Box>
						}
						filename={fileName}>
						{getMetaColumns({
							metaData,
						})}
						{getDataColumns({
							chartData,
						})}
					</ExcelFile>
				</MenuItem>
			</Menu>
		</>
	);
};

DownloadSupplierShare.propTypes = {
	data: PropTypes.arrayOf(PropTypes.shape({})),
	chartTitle: PropTypes.string,
};

export default DownloadSupplierShare;
